import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CgIcon from '@/components/atoms/cg-icon';
import styles from './authors.module.scss';

import {ImageSizes} from '@/constants/image-sizes.constant';
import Image from '@/components/atoms/image';

const AuthorsComponent = ({ author, index, showListMobile, raiseName = true}) => {
  const [showName, setShowName] = useState(false);

  const authorPhoto = author?.avatar?.location || '';
  const authorName = (author?.title || '');

  useEffect(()=>{
    if (author) {
      setShowName(false);
    }
  }, [author]);

  const getName = () => {
    const names = authorName.toUpperCase().split(' ');
    return `${names[0][0]}${names.length === 2 ? names[1][0] : ''}`;
  }

  const userImage = (onClickAction) => {
    return <div className='justify-content-center' onClick={onClickAction}>
      {authorPhoto ?
        <Image alt={`${authorName}'s profile picture`} className={styles.cgCoAuthor__img} src={authorPhoto} size={ImageSizes.THUMBNAIL} onMouseOutCapture={()=> setShowName(false)} onMouseOverCapture={()=> raiseName && setShowName(true)}/> :
        <div className={`${styles.cgCoAuthor__img} ${styles.cgCoAuthor__icon}`} onMouseOutCapture={()=> setShowName(false)} onMouseOverCapture={()=> raiseName && setShowName(true)}>{ getName() }</div>
      }
    </div>
  }

  const userImageLink = () => {
    return <a className='justify-content-center' href={null}>
      {authorPhoto ?
        <Image alt={`${authorName}'s profile picture`} className={styles.cgCoAuthor__img} src={authorPhoto} size={ImageSizes.THUMBNAIL} onMouseOutCapture={()=> setShowName(false)} onMouseOverCapture={()=> raiseName && setShowName(true)}/> :
        <div className={`${styles.cgCoAuthor__img} ${styles.cgCoAuthor__icon}`} onMouseOutCapture={()=> setShowName(false)} onMouseOverCapture={()=> raiseName && setShowName(true)}>{ getName() }</div>
      }
    </a>
  }

  return (
    <div className={styles[`cgCoAuthor__index${index}`]}>
      <div className="d-none d-sm-none d-md-block">
        {userImageLink()}
      </div>
      <div className="d-block d-md-none d-lg-none">
        {userImage(() => showListMobile(true))}
      </div>
      {showName && 
        <>
          <CgIcon iconName="AiFillCaretUp" className={styles.cgCoAuthor__nameArrow}></CgIcon>
          <b className={`mt-3 ${styles.cgCoAuthor__name}`} onClick={()=>{}}>{authorName}</b>
        </>}
    </div>
  );
};

AuthorsComponent.propTypes = {
  author: PropTypes.any,
  index: PropTypes.number,
  showListMobile: PropTypes.func,
  raiseName: PropTypes.bool,
};

export default AuthorsComponent;
